import { combineReducers } from "redux"
import mainReducer from "./main"

const rootReducer = combineReducers({
    mainReducer: mainReducer,
})

export default rootReducer;